import { cellByIndex, indexByCell, cellByPos } from './lib/utils';
import { cloneData, rotateData } from './utils';
import { calcCellSize, calcGridPos } from './components/Game/src/geometry';
export function shadow(slice, dataAfter) {
    var cellSize = calcCellSize();
    var gridPos = calcGridPos(cellSize);
    var slicePos = {
        x: slice.pos.x + slice.move.x - gridPos.x + cellSize / 2,
        y: slice.pos.y + slice.move.y - gridPos.y + cellSize / 2,
    };
    var cell0 = cellByPos(slicePos.x, slicePos.y, cellSize);
    if (checkPosition(slice, cell0, dataAfter, true)) {
        return dataAfter;
    }
    return;
}
export function checkLossWithRotate(slices, data) {
    for (var i = 0; i <= 3; i++) {
        if (i > 0) {
            data = rotateData(data, 9);
        }
        if (!checkLoss(slices, data)) {
            return false;
        }
    }
    return true;
}
export function checkLoss(slices, data) {
    for (var i = 0; i < slices.length; i++) {
        var slice = slices[i];
        if (!slice.hidden && findSpace(slice, data)) {
            return false;
        }
    }
    return true;
}
export function findSpace(slice, data) {
    for (var j = -2; j < 9; j++) {
        for (var i = -2; i < 9; i++) {
            if (checkPosition(slice, [i, j], data)) {
                return [i, j];
            }
        }
    }
    return false;
}
// Проверяет возможность размещения фигуры начиная с клетки "cell"
export function checkPosition(slice, cell, data, setShadow) {
    if (setShadow === void 0) { setShadow = false; }
    for (var i = 0; i < slice.data.length; i++) {
        if (slice.data[i].value) {
            var sliceCell = cellByIndex(i, slice.gridSize);
            var cellI = sumCell(cell, sliceCell);
            if (cellI[0] > -1 && cellI[1] > -1 && cellI[0] < 9 && cellI[1] < 9) {
                var index = indexByCell(cellI, 9);
                if (data[index].value) {
                    return false;
                }
                if (setShadow) {
                    data[index].shadow = slice.data[i].value;
                }
            }
            else {
                return false;
            }
        }
    }
    return true;
}
export function addShadow(slice, cell, data) {
    var clonedData = cloneData(data);
    for (var i = 0; i < slice.data.length; i++) {
        if (slice.data[i].value) {
            var sliceCell = cellByIndex(i, slice.gridSize);
            var cellI = sumCell(cell, sliceCell);
            if (cellI[0] > -1 && cellI[1] > -1 && cellI[0] < 9 && cellI[1] < 9) {
                var index = indexByCell(cellI, 9);
                if (data[index].value) {
                    throw new Error('Клетка занята');
                }
                clonedData[index].shadow = slice.data[i].value;
            }
            else {
                throw new Error('Выход за пределы поля');
            }
        }
    }
    return clonedData;
}
function sumCell(cellA, cellB) {
    return [cellA[0] + cellB[0], cellA[1] + cellB[1]];
}
